import { render, staticRenderFns } from "./zoneStyle4.vue?vue&type=template&id=07cb163b&scoped=true&"
import script from "./zoneStyle4.vue?vue&type=script&lang=ts&"
export * from "./zoneStyle4.vue?vue&type=script&lang=ts&"
import style0 from "./zoneStyle4.vue?vue&type=style&index=0&id=07cb163b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cb163b",
  null
  
)

export default component.exports